// Reserved for future IExtender instances. Flarum's `bootExtensions` iterates
// `extension.extend.forEach(...)`, so this export must exist as an array even
// when the forum frontend only patches things imperatively.
export default [];